import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { Component, OnInit, Input, OnDestroy } from "@angular/core";

const FRAME_DURATION = 30;
const ROTATION_DURATION = 1000;

@Component({
  selector: "loading-spinner",
  templateUrl: "./loading-spinner.component.html",
  styleUrls: ["./loading-spinner.component.scss"],
  animations: [
    trigger("rotateOnLoop", [
      state("IDLE", style({ transform: "rotateY(0deg)" })),
      state("ROTATING", style({ transform: "rotateY(180deg)" })),
      transition("IDLE => ROTATING", [
        animate("1000ms cubic-bezier(0.65, 0, 0.35, 1)"),
      ]),
      transition("ROTATING => IDLE", []),
    ]),
  ],
})
export class LoadingSpinnerComponent implements OnInit, OnDestroy {
  @Input() width = 32;
  @Input() height = 32;

  frames = Array.from(
    { length: 23 },
    (_, i) => `assets/images/loader/loader-frame-${i + 1}.svg`,
  );
  currentFrameIndex: number = 0;
  rotationState: "IDLE" | "ROTATING" = "IDLE";

  private frameDuration: number = FRAME_DURATION;
  private rotationDuration: number = ROTATION_DURATION;
  private timeoutId: any;
  private isRotating: boolean = false;

  ngOnInit() {
    this.frames.forEach((src) => (new Image().src = src));
    this.nextFrame();
  }

  ngOnDestroy() {
    clearTimeout(this.timeoutId);
  }

  getSpinnerDimensions(): { [key: string]: string } {
    return {
      width: this.width + "px",
      height: this.height + "px",
    };
  }

  nextFrame() {
    this.timeoutId = setTimeout(() => {
      if (
        this.currentFrameIndex === this.frames.length - 1 &&
        !this.isRotating
      ) {
        this.triggerRotation();
        return;
      }

      const next = (this.currentFrameIndex + 1) % this.frames.length;
      this.currentFrameIndex = next;
      this.nextFrame();
    }, this.frameDuration);
  }

  triggerRotation() {
    this.isRotating = true;
    this.rotationState = "ROTATING";

    setTimeout(() => {
      this.rotationState = "IDLE";
      this.isRotating = false;
      this.currentFrameIndex = 0;
      this.nextFrame();
    }, this.rotationDuration);
  }
}
